import axios from "axios"
import { I18n } from 'react-redux-i18n'

import {getUrlPrefix, getHeaders} from "../helpers/urlHelper"

export function deleteAppointment(id) {
  return function(dispatch) {
    dispatch({type: "DELETE_APPOINTMENT"})

    axios.delete(getUrlPrefix() + "/afspraak/"+id,
      {
        headers: getHeaders()
      })
      .then((response) => {

        dispatch({type: "DELETE_APPOINTMENT_FULFILLED", payload: id})

        // Show success snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'success',
          message: I18n.t('appointment.removed'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 1600
        }})
      })
      .catch((err) => {
        dispatch({type: "DELETE_APPOINTMENT_REJECTED", payload: err})

        if(err.response && err.response.status === 422) {

          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: err.response.data.message,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          }})

          dispatch({type: "NEW_APPOINTMENT_SET_ERRORS", payload: err.response.data})
        }else{
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('global.server_error'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 5000
          }})

        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/deleteAppointmentActions.js